// extracted by mini-css-extract-plugin
module.exports = {"controls":"sliderControls_controls__2GH8D","selected":"sliderControls_selected__3vsrG"};